import { ProjectInfo } from '@frontend-site/shared/data';
import { MenuItem } from '../../../models';
import { MENU_IDS } from '../../menu-ids';
import { Injectable } from '@angular/core';

@Injectable()
export class CorrectionsMenuFactory {
    constructor() {}
    public createCorrectionsMenu(projectInfo: ProjectInfo): MenuItem | null {
        if (projectInfo.isRestrictedApp()) {
            return null;
        }
        if (!CorrectionsMenuFactory.showCodeCorrection(projectInfo)) {
            return null;
        }

        const menu: MenuItem[] = [
            CorrectionsMenuFactory.createCorrectionPlanMenuItem(projectInfo),
            this.createCorrectionListMenuItem(projectInfo)
        ];

        if (!projectInfo.hrOnly && (projectInfo.isUpgradeProject() || projectInfo.isSupportPackageProject())) {
            menu.push(this.createCorrectionIssueListMenuItem(projectInfo.id));
        }

        return {
            id: MENU_IDS.PROJECT.CORRECTIONS.DEFAULT,
            label: 'Enumerations.ApplicationModules.CODE_CORRECTIONS',
            routePath: `/tm/${projectInfo.id}/ia/corrections`,
            menu
        };
    }
    public static showCodeCorrection(projectInfo: ProjectInfo): boolean {
        return (
            projectInfo.isOraclePatchesProject() ||
            (projectInfo.isSupportPackageProject() && !projectInfo.isSpsNew()) ||
            projectInfo.isUpgradeProject() ||
            projectInfo.isCleansingProject() ||
            projectInfo.isOracleUpgradeProject() ||
            projectInfo.isVfStandaloneProject() ||
            projectInfo.isOracleOnlinePatchesProject()
        );
    }
    public static createCorrectionPlanMenuItem(project: ProjectInfo): MenuItem {
        return {
            id: MENU_IDS.PROJECT.CORRECTIONS.CORRECTION_PLAN,
            label: project.isIncludesAccAnalysisProject() ? `Corrections breakdown` : `Correction Plan`,
            routePath: `/tm/${project.id}/ia/corrections/correctionPlan`
        };
    }
    public createCorrectionListMenuItem(project: ProjectInfo): MenuItem {
        return {
            id: MENU_IDS.PROJECT.CORRECTIONS.DEFAULT,
            label: 'Enumerations.ApplicationModules.CODE_CORRECTIONS',
            routePath: `/${project.id}/corrections/list`
        };
    }
    public createCorrectionIssueListMenuItem(projectId: number): MenuItem {
        return {
            id: MENU_IDS.PROJECT.CORRECTIONS.ISSUES,
            label: 'Enumerations.ApplicationModules.CORRECTION_ISSUES',
            routePath: `/${projectId}/issues/list`
        };
    }
}
